import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RetrieverExecutionTokens } from '../../services/retrievers.service';

interface ResultEntry {
  key: string;
  value: any;
  isGroup: boolean;
}

interface TokenItem {
  labelKey: string;
  value: number;
}

@Component({
  selector: 'app-retriever-result-view',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './retriever-result-view.component.html',
  styleUrls: ['./retriever-result-view.component.scss'],
})
export class RetrieverResultViewComponent {
  @Input() result: any = null;
  @Input() tokens: RetrieverExecutionTokens | null = null;

  get errorMessage(): string | null {
    if (this.result && typeof this.result === 'object' && typeof this.result.error === 'string') {
      return this.result.error;
    }
    return null;
  }

  get entries(): ResultEntry[] {
    if (!this.result || typeof this.result !== 'object' || this.errorMessage) {
      return [];
    }
    return Object.keys(this.result)
      .filter(key => key !== 'error')
      .map(key => {
        const value = this.result[key];
        return { key, value, isGroup: Array.isArray(value) };
      });
  }

  get tokenItems(): TokenItem[] {
    const t = this.tokens;
    if (!t) return [];
    const items: TokenItem[] = [];
    if (t.input_tokens != null) items.push({ labelKey: 'RETRIEVERS.EXECUTE.TOKENS_INPUT', value: t.input_tokens });
    if (t.output_tokens != null) items.push({ labelKey: 'RETRIEVERS.EXECUTE.TOKENS_OUTPUT', value: t.output_tokens });
    if (t.total_tokens != null) items.push({ labelKey: 'RETRIEVERS.EXECUTE.TOKENS_TOTAL', value: t.total_tokens });
    if (t.embedding_tokens != null) items.push({ labelKey: 'RETRIEVERS.EXECUTE.TOKENS_EMBEDDING', value: t.embedding_tokens });
    return items;
  }

  objectEntries(obj: any): { key: string; value: any }[] {
    if (!obj || typeof obj !== 'object') return [];
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }

  formatValue(value: any): string {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  }

  isEmptyResult(): boolean {
    return !this.errorMessage && this.entries.length === 0;
  }
}
